export enum CustomGridListCellType {
    string = 0,
    numeric
}
